<template>
  <div class="operational-dashboard-section">
    <h4 class="operational-dashboard-section__title">
      {{ $t('OPERATIONAL_DASHBOARD.PRIORITY.TITLE') }}
    </h4>
    <horizontal-bar
      v-for="row in rows"
      :key="row.key"
      :label="row.label"
      :count="row.count"
      :total="total"
      :color="row.color"
    />
  </div>
</template>

<script>
import HorizontalBar from './HorizontalBar.vue';

const PRIORITY_ROWS = [
  { key: 'urgent', color: '#E23D28' },
  { key: 'high', color: '#F2994A' },
  { key: 'medium', color: '#F2C94C' },
  { key: 'low', color: '#2F80ED' },
  { key: '', color: '#9AA5B1' },
];

export default {
  name: 'PriorityBreakdown',
  components: { HorizontalBar },
  props: {
    conversationsByPriority: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    total() {
      return Object.values(this.conversationsByPriority).reduce(
        (sum, count) => sum + count,
        0
      );
    },
    rows() {
      return PRIORITY_ROWS.map(({ key, color }) => ({
        key: key || 'none',
        color,
        count: this.conversationsByPriority[key] || 0,
        label: this.$t(
          `OPERATIONAL_DASHBOARD.PRIORITY.${(key || 'none').toUpperCase()}`
        ),
      }));
    },
  },
};
</script>

<style lang="scss" scoped>
.operational-dashboard-section {
  background: var(--white);
  border: 1px solid var(--color-border);
  border-radius: var(--border-radius-medium);
  padding: var(--space-medium) var(--space-large);

  &__title {
    color: var(--s-900);
    font-size: var(--font-size-medium);
    font-weight: var(--font-weight-bold);
    margin-bottom: var(--space-medium);
  }
}
</style>
